"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LeftnavController = function () {
  function LeftnavController(NavigationService, AppContextService, EventsService) {
    "ngInject";

    (0, _classCallCheck3.default)(this, LeftnavController);
    this.navigationService = NavigationService;
    this.appContextService = AppContextService;
    this.eventsService = EventsService;
    this.displayAdminNav = false;
    this.displayAnalyticsNav = false;
  }

  (0, _createClass3.default)(LeftnavController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.appContext = this.appContextService.getAppContext();

      this.eventsService.listen(_constants2.default.events.AUTHORIZATION_SUCCESS, function () {
        _this.appContext = _this.appContextService.getAppContext();
        _this.setLeftNavVisibility(_this.appContext);
        console.log("AUTHORIZATION_SUCCESS Event listener called", _this.appContext);
      });
    }
  }, {
    key: "setLeftNavVisibility",
    value: function setLeftNavVisibility(appContext) {
      if (this.appContextService.isAdmin()) this.displayAdminNav = true;
      if (this.appContextService.isAnalytics()) this.displayAnalyticsNav = true;

      if (appContext && appContext.roles) {

        // Check if user has ONLY read access (no admin or global admin)
        if (this.appContextService.hasReadAccess(appContext.roles) && !appContext.roles.includes('Admin') && !appContext.roles.includes('GlobalAdmin')) this.hasOnlyReadAccess = true;else this.hasOnlyReadAccess = false;

        if (this.appContextService.hasGlobalAdminAccess(appContext.roles)) this.hasGlobalAdminAccess = true;else this.hasGlobalAdminAccess = false;
      }
    }
  }, {
    key: "isCurrentPage",
    value: function isCurrentPage(page) {
      return this.navigationService.isCurrent(page);
    }
  }]);
  return LeftnavController;
}();

exports.default = LeftnavController;


/** WEBPACK FOOTER **
 ** ./client/app/common/Components/leftnav/leftnav.controller.js
 **/